<article class="donut-card">
  <header class="donut-card__header">
    <div class="donut-card__headings">
      <h3 class="donut-card__title">{{ title }}</h3>
      <p class="donut-card__kpi">{{ primaryCount }}</p>
      <p
        class="donut-card__subtitle">{{ donutCardComponent()?.totalOfSurveysLabel }} {{ totalCount }} {{ donutCardComponent()?.employeesLabel }}</p>
    </div>
    @if (rightHint) {
      <div class="donut-card__right-hint">{{ rightHint }}</div>
    }
  </header>

  <div class="donut-card__body">
    <div class="donut-figure">
      <app-donut-chart
        [data]="donutData"
        [customColors]="donutColors"
        [arcWidth]="0.5"
        [view]="[200,200]"
        [showLegend]="false">
      </app-donut-chart>

      <!-- overlay -->
      <svg class="donut-overlay" viewBox="0 0 200 200" aria-hidden="true">
        @if (firstPct() > 0) {
          <text
            class="donut__label"
            [attr.fill]="firstTextColor()"
            [attr.x]="posFor(firstPct(), 0, -15).x"
            [attr.y]="posFor(firstPct(), 0, -15).y">
            {{ firstPct() }}%
          </text>
        }
        @if (secondPct() > 0) {
          <text
            class="donut__label"
            [attr.fill]="secondTextColor()"
            [attr.x]="posFor(secondPct(), firstPct(), -15).x"
            [attr.y]="posFor(secondPct(), firstPct(), -15).y">
            {{ secondPct() }}%
          </text>
        }
      </svg>
    </div>

    <ul class="legend">
      <li>
        <span class="dot" [style.background]="normalizedColors.sec"></span>
        {{ secondaryLabel }}
      </li>
      <li>
        <span class="dot" [style.background]="normalizedColors.pri"></span>
        {{ primaryLabel }}
      </li>
    </ul>
  </div>
</article>
